<template>
    <div style="position: relative;">
        <router-view style="min-height: calc(100vh - 14rem);"></router-view>

        <partners-list></partners-list>

        <footer class="my-5">
            <div class="container">
                <div class="content has-text-centered">
                    <p v-html="$t('footer_copyrights', { year: (new Date()).getFullYear() })"></p>
                    <p class="is-size-7"><a :href="$t('public_site_uri')" target="_blank">{{ $t('public_site_label') }}</a> · <a :href="$t('terms_uri')" target="_blank">{{ $t('terms_label') }}</a> · <a :href="$t('privacy_policy_uri')" target="_blank">{{ $t('privacy_policy_label') }}</a> · <a :href="$t('cookie_policy_uri')" target="_blank">{{ $t('cookie_policy_label') }}</a></p>
                </div>
            </div>
        </footer>

        <div class="cookie-notification-container" v-if="showCookieNotification">
            <div class="notification is-info">
                <span v-text="$t('cookie_notification')"></span>
                <button class="delete" @click="consentCookies()"></button>
            </div>
        </div>

        <recommendations-modal
            :active="showRecommendationsModal"
            @close="closeRecommendationsModal()"></recommendations-modal>

        <b-loading :active="isLoading"></b-loading>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import { store } from '@/store'
import helpers from '@/mixins/helpers'
import moment from 'moment'

import RecommendationsModal from '@/components/Doctor/RecommendationsModal.vue'
import PartnersList from '@/components/Doctor/PartnersList.vue'

export default {
    name: 'DoctorLayout',

    mixins: [helpers],

    components: {RecommendationsModal, PartnersList},

    data() {
        return {
            consentForCookies: false,
            closedRecommendationsModal: false
        }
    },

    computed: {
        showCookieNotification() {
            return ! this.doctor && ! this.consentForCookies
        },

        showRecommendationsModal() {
            return this.doctor && ! this.closedRecommendationsModal && Object.keys(this.recommendations).length < 1 ? true : false
        }
    },

    beforeMount () {
        const language = this.doctor ? this.doctor.language : 'en'
        window.location.href = `https://pro.tooddoc.com/login?source=old_version&lang=${language}`
    },

    mounted () {
        this.consentForCookies = this.hasGivenConsentForCookies()
        this.closedRecommendationsModal = this.hasClosedRecommendationsModal()
        if (this.doctor) {
            this.setLocale(this.doctor.language)
        }
    },

    methods: {
        hasClosedRecommendationsModal() {
            if (this.closedRecommendationsModal) return true

            var value = '; ' + document.cookie
            var parts = value.split('; closed_recommendations=')

            return parts.length != 2 ? false : true
        },

        closeRecommendationsModal() {
            var expirationDate = moment().add(1, 'days')

            var cookie = [
                'closed_recommendations=1',
                'expires=' + expirationDate.utc().toString(),
                'path=/'
            ]

            document.cookie = cookie.join(';')

            this.closedRecommendationsModal = true
        },

        hasGivenConsentForCookies() {
            if (this.consentForCookies) return true

            var value = '; ' + document.cookie
            var parts = value.split('; cookieconsent_status=')

            return parts.length != 2 ? false : true
        },

        consentCookies() {
            var expirationDate = moment().add(365, 'days')

            var cookie = [
                'cookieconsent_status=1',
                'expires=' + expirationDate.utc().toString(),
                'path=/'
            ]

            document.cookie = cookie.join(';')

            this.consentForCookies = true
        }
    }
}
</script>

<style src="../assets/scss/app.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/layouts/DoctorLayout.vue